// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__32fHZ","col":"styles_col__2R6jw"};